export const WEEKDAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];

export const DEFAULT_SETTINGS = {
  companyName: "SparkingCircle",
  appName: "SparkingCircle",
  companyLogo: "",
  defaultShiftStart: "11:00",
  defaultShiftEnd: "21:30",
  fullDayOutBy: "21:00",
  halfDayCutoff: "15:00",
  graceMinutes: 30,
  outsideGeofenceMode: "exception",
  monthlyHalfDay: 0.5,
  staffWelfarePerPresentDay: 20,
  payrollStatus: "Draft",
  enabledModules: {
    attendance: true,
    work: true,
    salesTargets: true,
    opticalOrders: true,
    cnTracking: true,
    payroll: true,
    advances: true,
    reimbursements: true,
    incentives: true
  }
};

export const SEED_STORES = [
  {
    id: "store-noida",
    name: "Framesbay / Amrapali Zodiac Market Noida",
    code: "NOIDA",
    address: "Amrapali Zodiac Market Noida",
    latitude: 28.585242,
    longitude: 77.399127,
    radiusMeters: 150,
    geofenceEnabled: true,
    active: true
  },
  {
    id: "store-ivision",
    name: "iVision / Amrapali Zodiac Market Noida",
    code: "IVISION",
    address: "Amrapali Zodiac Market Noida",
    latitude: 28.585242,
    longitude: 77.399127,
    radiusMeters: 150,
    geofenceEnabled: true,
    active: true
  },
  {
    id: "store-crossings",
    name: "Framesbay / Orbit Mall Crossing Republik",
    code: "CROSS",
    address: "Orbit Mall / Orbit Plaza Crossing Republik Ghaziabad",
    latitude: 28.631014,
    longitude: 77.435203,
    radiusMeters: 150,
    geofenceEnabled: true,
    active: true
  },
  {
    id: "store-gaur-city",
    name: "LYF Hospital / Gaur City",
    code: "GAUR",
    address: "Gaur City opposite City Plaza",
    latitude: 28.61428,
    longitude: 77.432232,
    radiusMeters: 150,
    geofenceEnabled: true,
    active: true
  }
];

export const SEED_EMPLOYEES = [
  {
    id: "emp-dharmendra",
    employeeCode: "FB-001",
    fullName: "Dharmendra",
    phone: "",
    email: "dharmendra@framesbay.local",
    storeId: "store-noida",
    designation: "Optical Store Staff",
    monthlySalary: 28300,
    weeklyOffDay: "Friday",
    joiningDate: "2026-04-01",
    exitDate: "",
    active: true,
    openingLeaveBalance: 0,
    openingLoanBalance: 0,
    incentiveEligible: true,
    reimbursementEligible: true,
    bankDetails: "",
    notes: ""
  },
  {
    id: "emp-sumit",
    employeeCode: "FB-002",
    fullName: "Sumit",
    phone: "",
    email: "sumit@framesbay.local",
    storeId: "store-gaur-city",
    designation: "Optical Store Staff",
    monthlySalary: 18500,
    weeklyOffDay: "Wednesday",
    joiningDate: "2026-04-01",
    exitDate: "",
    active: true,
    openingLeaveBalance: 0,
    openingLoanBalance: 0,
    incentiveEligible: true,
    reimbursementEligible: true,
    bankDetails: "",
    notes: ""
  },
  {
    id: "emp-alam",
    employeeCode: "FB-003",
    fullName: "Mohd. Alam",
    phone: "",
    email: "alam@framesbay.local",
    storeId: "store-ivision",
    designation: "Optical Store Staff",
    monthlySalary: 25500,
    weeklyOffDay: "Friday",
    joiningDate: "2026-04-01",
    exitDate: "",
    active: true,
    openingLeaveBalance: 0,
    openingLoanBalance: 0,
    incentiveEligible: true,
    reimbursementEligible: true,
    bankDetails: "",
    notes: ""
  },
  {
    id: "emp-gulveer",
    employeeCode: "FB-004",
    fullName: "Gulveer Singh",
    phone: "",
    email: "gulveer@framesbay.local",
    storeId: "store-ivision",
    designation: "Optical Store Staff",
    monthlySalary: 21500,
    weeklyOffDay: "Thursday",
    joiningDate: "2026-04-01",
    exitDate: "",
    active: true,
    openingLeaveBalance: 0,
    openingLoanBalance: 0,
    incentiveEligible: true,
    reimbursementEligible: true,
    bankDetails: "",
    notes: ""
  },
  {
    id: "emp-virendra",
    employeeCode: "FB-005",
    fullName: "Virendra",
    phone: "",
    email: "virendra@framesbay.local",
    storeId: "store-crossings",
    designation: "Optical Store Staff",
    monthlySalary: 35000,
    weeklyOffDay: "Wednesday",
    joiningDate: "2026-04-01",
    exitDate: "",
    active: true,
    openingLeaveBalance: 0,
    openingLoanBalance: 0,
    incentiveEligible: true,
    reimbursementEligible: true,
    bankDetails: "",
    notes: ""
  },
  {
    id: "emp-amandeep",
    employeeCode: "FB-006",
    fullName: "Amandeep Yadav",
    phone: "",
    email: "amandeep@framesbay.local",
    storeId: "store-ivision",
    designation: "Optical Store Staff",
    monthlySalary: 0,
    weeklyOffDay: "",
    joiningDate: "2026-04-01",
    exitDate: "",
    active: true,
    openingLeaveBalance: 0,
    openingLoanBalance: 0,
    incentiveEligible: false,
    reimbursementEligible: true,
    bankDetails: "",
    notes: "Salary and weekly off not confirmed yet."
  }
];

export const SEED_USERS = [
  {
    id: "user-super-admin",
    name: "Super Admin",
    email: "admin@framesbay.local",
    role: "super_admin",
    employeeId: "",
    storeIds: []
  },
  {
    id: "user-store-manager",
    name: "Store Manager",
    email: "manager@framesbay.local",
    role: "admin",
    employeeId: "",
    storeIds: ["store-noida", "store-ivision"]
  },
  {
    id: "user-dharmendra",
    name: "Dharmendra",
    email: "dharmendra@framesbay.local",
    role: "employee",
    employeeId: "emp-dharmendra",
    storeIds: ["store-noida"]
  }
];

export const SEED_INCENTIVE_RULES = [
  { employeeId: "emp-dharmendra", storeId: "store-noida", threshold: 300000, rate: 0.01, payDelayMonths: 3 },
  { employeeId: "emp-dharmendra", storeId: "store-noida", threshold: 400000, rate: 0.02, payDelayMonths: 3 },
  { employeeId: "emp-sumit", storeId: "store-gaur-city", threshold: 300000, rate: 0.01, payDelayMonths: 3 },
  { employeeId: "emp-sumit", storeId: "store-gaur-city", threshold: 400000, rate: 0.015, payDelayMonths: 3 },
  { employeeId: "emp-alam", storeId: "store-ivision", threshold: 300000, rate: 0.01, payDelayMonths: 3, splitPercent: 50 },
  { employeeId: "emp-alam", storeId: "store-ivision", threshold: 400000, rate: 0.015, payDelayMonths: 3, splitPercent: 50 },
  { employeeId: "emp-gulveer", storeId: "store-ivision", threshold: 300000, rate: 0.01, payDelayMonths: 3, splitPercent: 50 },
  { employeeId: "emp-virendra", storeId: "store-crossings", threshold: 300000, rate: 0.01, payDelayMonths: 3 },
  { employeeId: "emp-virendra", storeId: "store-crossings", threshold: 400000, rate: 0.015, payDelayMonths: 3 }
];
